<template>
  <div class="grid grid-cols-1 md:grid-cols-12 md:gap-4">
    <div class="col-span-12 md:col-span-12 pb-3">
      <div class="flex flex-col bg-white md:gap-3 p-4 shadow rounded-2xl">
        <div
          v-if="props.showBackButton"
         >
        <p 
          @click="backhistory"
          class="flex items-center cursor-pointer  w-1/6" 
        >
          <h1>
            <ChevronLeft class="w-6 h-6 text-gray-400" />
          </h1>
          <span>Voltar</span>

        </p>
        </div>
        <div class="flex justify-between items-center">
          <h4 class="text-tservebg font-bold text-[24px]">{{ props.title }}</h4>
          <button
            v-if="props.showExportInscriptionFile"
            type="button"
            class="px-3 py-2 rounded-full text-white flex items-center gap-2 font-bold bg-gray-500"
          >
            Exportar para pdf <Download class="w-4 h-4" />
          </button>
          <div class="flex gap-2" v-if="props.showTypeInscription">
            <button
              type="button"
              class="px-3 py-2 text-white flex items-center gap-2 font-bold bg-gray-500"
            >
              Tipo de Inscrição:
              <span class="underline text-coral-red">
                {{ props.InsriptionStatus }}</span
              >
            </button>
            <button
              v-if="props.inscription_paid == 1"
              type="button"
              class="px-3 py-2 text-white flex items-center gap-2 font-bold bg-gray-500"
            >
              Status:
              <span class="underline text-green-500"> Paga</span>
            </button>
            <button
              v-else
              type="button"
              class="px-3 py-2 text-white flex items-center gap-2 font-bold bg-gray-500"
            >
              Status:
              <span class="underline text-coral-red"> Não Paga</span>
            </button>
          </div>
        </div>
        <div class="flex gap-3 max-w-xl flex-wrap md:flex-nowrap">
          <!-- Input de pesquisa -->
          <div
            v-if="props.showInputSearchProd"
            class="flex gap-2 border border-red-300 text-gray-900 text-sm rounded-md w-full p-2.5"
          >
            <Search class="text-gray-300" size="16" />
            <input
              type="text"
              :placeholder="props.placeholder"
              class="w-full bg-transparent outline-none focus:ring-green-300 focus:border-green-300"
              v-model="searchQueryInternal"
            />
          </div>

          <!-- Botão Adicionar -->
          <button
            v-if="props.showAddButton"
            @click="setModalOpen(true)"
            type="button"
            class="flex items-center px-3 py-1 rounded-sm bg-red-400 text-white font-bold text-sm gap-1 whitespace-nowrap"
          >
            {{ props.labelAddButton }}
            <component
              :is="props.iconType === 'Add' ? PlusCircle : Megaphone"
              size="18"
            />
          </button>

          <!-- Botão Atualizar -->
          <button
            v-if="props.showSyncroniseBtn"
            @click="setSyncData(true)"
            type="button"
            class="flex bg-red-400 items-center px-4 py-1 rounded-sm text-white font-bold text-sm gap-1 whitespace-nowrap"
          >
            Actualizar
            <RefreshCcw
              :size="18"
              :class="{ 'animate-spin': props.syncData }"
            />
          </button>
        </div>

        <!-- Filtros adicionais -->
        <div
          v-if="props.showDateInterval"
          class="grid grid-cols-1 md:grid-cols-3 max-w-3xl items-center gap-2 flex-wrap"
        >
          <BaseInput
            type="date"
            label="De"
            :placeholder="props.placeholder"
            class="focus:outline-none font-semibold text-[13px]"
            v-model="start_date_internal"
          />
          <BaseInput
            type="date"
            label="Ate"
            :placeholder="placeholder"
            class="focus:outline-none font-semibold text-[13px]"
            v-model="end_date_internal"
          />
        </div>

        <div
          v-if="props.showYear"
          class="grid grid-cols-1 md:grid-cols-3 max-w-3xl items-center gap-2 flex-wrap"
        >
          <BaseSelect
            :data="years"
            label="Ano"
            :placeholder="props.placeholder"
            class="focus:outline-none font-semibold text-[13px]"
            v-model="entryYearInternal"
          />

          <BaseSelect
            :data="[
              { id: '', name: 'Selecionar o tipo de busca' },
              { id: 'pagas', name: 'Pagas' },
              { id: 'Pendentes', name: 'Pendentes' },
              { id: 'Candidaturas', name: 'Candidaturas' },
              { id: 'renovacao', name: 'Renovações' },
              { id: 'renovacao-pendentes', name: 'Renovações pendentes' },
            ]"
            label="Tipo de busca"
            :placeholder="props.placeholder"
            class="focus:outline-none font-semibold text-[13px]"
            v-model="typeFilterInscriptionInternal"
          />
        </div>
        <div
          v-if="
            props.InsriptionStatus === 'Candidatura' &&
            props.inscription_paid == 0
          "
        >
          <p>
            Nota: Após a verificação de que o estudante cumpre todos os
            requisitos estabelecidos e que o respetivo pagamento foi devidamente
            efetuado, proceda com a confirmação da matrícula através do botão
            abaixo.
          </p>
          <button
            @click="handleConfirmInscription"
            type="button"
            class="px-3 py-2 rounded-full text-white flex bg-green-500 items-center gap-2 font-bold"
          >
            Confirmar a Matrícula
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, watch } from "vue";
import {
  ChevronLeft,
  Download,
  Megaphone,
  PlusCircle,
  RefreshCcw,
  Search,
} from "lucide-vue-next";
import BaseInput from "../BaseInput.vue";
import { useCan } from "../../hooks/useCan.js";
import BaseSelect from "../BaseSelect.vue";
import { useRouter } from "vue-router";

const years = ref([]);
const router = useRouter();

// Props
const props = defineProps({
  title: String,
  searchQuery: String,
  setSearchQuery: Function,
  setModalOpen: Function,
  setSyncData: Function,
  syncData: Boolean,
  placeholder: String,
  labelAddButton: String,
  showSyncroniseBtn: Boolean,
  iconType: String,
  statusSelect: Array,
  setStartDate: Function,
  setEndDate: Function,
  setPaymentMethod: Function,
  start_date: String,
  end_date: String,
  yearSelected: String,
  status: String,
  showAddButton: Boolean,
  showInputStatus: Boolean,
  showInputSearchProd: Boolean,
  permission: String,
  showDateInterval: Boolean,
  showYear: Boolean,
  showInscriptionFilter: Boolean,
  showExportInscriptionFile: Boolean,
  typeSearch: String,
  setEntryYear: Function,
  entryYear: String,
  typeFilterInscription: String,
  setTypeFilterInscription: Function,
  showTypeInscription: Boolean,
  InsriptionStatus: String,
  inscription_paid: Number,
  showBackButton: Boolean,
});

const emit = defineEmits(["confirm-Payment"]);

const handleConfirmInscription = () => emit("confirm-Payment");

// Composables / métodos
const can = useCan();
function getYear() {
  let _currentYear = new Date().getFullYear();
  years.value.push({ id: "", name: "Selecionar o ano" });
  for (let index = _currentYear; index >= 2025; index--) {
    years.value.push({ id: index, name: index });
  }
}

// Estados internos para v-model
const searchQueryInternal = ref(props.searchQuery);
const start_date_internal = ref(props.start_date);
const end_date_internal = ref(props.end_date);
const status_internal = ref(props.status);
const typeFilterInscriptionInternal = ref(props.typeFilterInscription);
const entryYearInternal = ref(props.entryYear);

const backhistory = () => {
  router.back();
};

// Watchers para refletir mudanças no parent
watch(searchQueryInternal, (val) => props.setSearchQuery(val));
watch(typeFilterInscriptionInternal, (val) =>
  props.setTypeFilterInscription(val)
);
watch(entryYearInternal, (val) => props.setEntryYear(val));
watch(searchQueryInternal, (val) => props.setSearchQuery(val));
watch(start_date_internal, (val) => props.setStartDate(val));
watch(end_date_internal, (val) => props.setEndDate(val));
watch(status_internal, (val) => props.setPaymentMethod(val));

onMounted(() => {
  getYear();
});
</script>
